module.exports = __webpack_public_path__ + "img/tool-list.54cc5ac9.svg";